var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{attrs:{"center":_vm.location,"zoom":_vm.zoom,"map-type-id":"terrain"}},[_c('gmap-marker',{attrs:{"icon":{url: require('images/icon_map_marker.svg'), scaledSize: { width: 39, height: 62 }},"position":_vm.location,"optimized":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }